module.exports = __webpack_public_path__ + "static/media/cookhelper.3b02f5ff.jpg";